import { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Center, Loader, SimpleGrid, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import { useGetBadgeTemplates, useDeleteBadgeTemplate } from "../api/badges";
import { useDeleteConfirm } from "../hooks/useDeleteConfirm";
import CreateBadge from "../components/Badges/CreateBadge";
import BadgeCard from "../components/Badges/BadgeCard";

function Badges() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const eventId = currentWorkspace.eventId;

  const [createOpened, setCreateOpened] = useState(false);
  const [copySource, setCopySource] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const actions = useMemo(
    () => [
      {
        label: "Create",
        icon: <IconPlus />,
        onClick: () => setCreateOpened(true),
      },
    ],
    []
  );
  useSetActionButtons(actions);

  const { data, isPending } = useGetBadgeTemplates({ eventId });

  const { mutate: deleteBadge } = useDeleteBadgeTemplate({ id: deleteId });
  const confirmDelete = useDeleteConfirm("badge", deleteBadge, {
    message: "Are you sure you want to delete this badge template?",
  });

  const badges = data || [];

  const handleEdit = (badge) => navigate(`/app/badges/${badge.id}`);
  const handleDelete = (badge) => {
    setDeleteId(badge.id);
    confirmDelete();
  };

  return (
    <>
      {isPending ? (
        <Center py="xl">
          <Loader />
        </Center>
      ) : badges.length === 0 ? (
        <Center py="xl">
          <Text c="dimmed">No badge templates found</Text>
        </Center>
      ) : (
        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
          {badges.map((badge) => (
            <BadgeCard
              key={badge.id}
              badge={badge}
              isCheckInBadge={!!badge.isDefault}
              onCopy={setCopySource}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          ))}
        </SimpleGrid>
      )}

      <CreateBadge
        opened={createOpened}
        onClose={() => setCreateOpened(false)}
      />

      <CreateBadge
        key={copySource?.id}
        opened={!!copySource}
        onClose={() => setCopySource(null)}
        source={copySource}
      />
    </>
  );
}

export default Badges;
